import React from "react";
import { string, object, number, array, func, bool } from "prop-types";
import { LoadMoreCollectionStories } from "@quintype/components";

import SixStories1WidgetWithPoll from "../SixStories1WidgetWithPoll";
import Stories2AdWithLoadMore from "../Stories2AdWithLoadMore";
import { DfpComponent } from "../../ads/dfp-component";
import DfpContainer from "../../ads/dfp-container";

import { getSlotId } from "../../utils/utils";

const NO_OF_STORIES_TO_LOAD = 6;

const SixteenStories1WidgetWithPollAndLoadMore = ({ collectionSlug, stories, widgetUrl, widgetHeight, lang }) => {
  const list = stories.map((story) => story);
  const firstStoriesSet = list.slice(0, 6);
  const remainingStoriesSet = list.map(({ story }) => story).slice(0, 16);

  if (!(list && list.length)) {
    return null;
  }

  const ads = {
    B1: {
      en: "EnPalo_ROS_468x60_B1",
      bn: "News_468x60_B1",
    },
  };

  return (
    <div>
      {firstStoriesSet && (
        <SixStories1WidgetWithPoll
          isSectionComponent={true}
          firstStoriesSet={firstStoriesSet}
          widgetUrl={widgetUrl}
          widgetHeight={widgetHeight}
        />
      )}
      <DfpContainer>
        <div className="adsBox">
          <DfpComponent
            type={ads.B1[lang]}
            slotId={getSlotId(ads.B1[lang], collectionSlug, "SixteenStories1WidgetWithPollAndLoadMore")}
            collectionSlug={collectionSlug}
          />
        </div>
      </DfpContainer>
      {stories.length > 6 && (
        <LoadMoreCollectionStories
          collectionSlug={collectionSlug}
          template={MoreCollectionStories}
          data={{ stories: remainingStoriesSet }} // passing all the stories and set offSet=20 , since first 20 stories are passed to two components
          numStoriesToLoad={NO_OF_STORIES_TO_LOAD}
        />
      )}
    </div>
  );
};

const MoreCollectionStories = ({ stories, onLoadMore, loading, noMoreStories }) => (
  <Stories2AdWithLoadMore
    list={stories.slice(6, stories.length)} // sliced first 10 stories for the first component and display next 10 stories initally to second component
    loading={loading}
    onLoadMore={onLoadMore}
    isMoreStories={NO_OF_STORIES_TO_LOAD < stories.slice(6, stories.length).length && !noMoreStories}
  />
);

SixteenStories1WidgetWithPollAndLoadMore.propTypes = {
  accentColor: string,
  collection: object,
  numberOfCardsInViewDesktop: number,
  numberOfCardsInViewTablet: number,
  numberOfCardsInViewMobile: number,
  stories: array,
  collectionSlug: string,
  widgetUrl: string,
  widgetHeight: string,
  lang: string,
};

MoreCollectionStories.propTypes = {
  stories: array.isRequired,
  onLoadMore: func,
  noMoreStories: number,
  loading: bool,
};

SixteenStories1WidgetWithPollAndLoadMore.storyLimit = 16;

export default SixteenStories1WidgetWithPollAndLoadMore;
